<template>
  <div id="functionBar">
    <template v-for="(item, index) in buttonsObj">
      <a-dropdown v-if="item.title != ''">
        <span v-if="item.title == 'MORE'">
           <img class="mt4 ml4" src="../../../assets/img/ss-more.png" width="15" height="15" >
        </span>
        <span v-else-if="item.title == 'IREPORT'">
           <img class="mt4 ml4" src="../../../assets/img/ss-import.png" width="16" height="16" >
        </span>
        <span v-else>
          <a-button type="primary" size="small">
            <span>{{ item.title }}</span>
            <a-icon type="down" style="font-size: 12px" />
          </a-button>
        </span>
        <a-menu slot="overlay" style="overflow: auto;" :style="'max-height:' + moreHeight + 'px'">
          <a-menu-item
            v-for="it in item.children"
            @click="handleToolClick(it)"
            v-if="it.editFlag == undefined"
          >
            <span>
              <a-icon
                style="font-size: 16px"
                type="export"
                v-if="it.code == 'BTN_EXPORT'"
              />
              <a-icon
                style="font-size: 16px"
                type="save"
                v-else-if="it.code == 'BTN_SAVE'"
              />
              <!--<a-icon-->
                <!--style="font-size: 16px"-->
                <!--type="select"-->
                <!--v-else-if="it.code == 'BTN_IMPORT'"-->
              <!--/>-->
              <img  v-else-if="it.code == 'BTN_IMPORT'" style="margin-right: 7px;" src="../../../assets/img/ss-import.png" width="16" height="16">
              <a-icon
                style="font-size: 16px"
                type="copy"
                v-else-if="it.code == 'BTN_COPY'"
              />
              <a-icon
                style="font-size: 16px"
                type="plus"
                v-else-if="it.code == 'BTN_ADD'"
              />
              <a-icon
                style="font-size: 16px"
                type="delete"
                v-else-if="it.code == 'BTN_DELETE'"
              />
              <a-icon
                       style="font-size: 16px"
                       type="delete"
                       v-else-if="it.code == 'BTN_CANCEL'"
              />
              <a-icon
                style="font-size: 16px"
                type="printer"
                v-else-if="it.code == 'BTN_PRINT'"
              />
              <a-icon
                      style="font-size: 16px"
                      type="save"
                      v-else-if="it.code == 'BTN_UPDATE'"
              />
              <span style="font-size: 12px;margin-left: 2px">{{it.name}}</span>
            </span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <div v-else style="cursor:pointer;display: flex; justify-content: center">
        <template v-for="(tt, ii) in item.children">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ tt.name }}</span>
            </template>
            <img class="mt4"  v-if="tt.code == 'BTN_ADD' && tt.editFlag != '1'" @click="handleToolClick(tt)" src="../../../assets/img/ss-add.png"  width="15" height="15">
            <img class="mt4" v-else-if="tt.code == 'BTN_DELETE'"  @click="handleToolClick(tt)" src="../../../assets/img/ss-delete.png" width="15" height="15">
            <img class="mt4" v-if="tt.editFlag != '1' && tt.code == 'BTN_EDIT'" @click="handleToolClick(tt)" src="../../../assets/img/ss-edit.png" width="15" height="15">
            <img class="sbxs mt4" v-else-if="tt.code == 'BTN_REFRESH'" @click="handleToolClick(tt)" src="../../../assets/img/ss-refresh.png" width="15" height="15">
            <img class="sbxs mt4" v-else-if="tt.code == 'BTN_IMPORT'" @click="handleToolClick(tt)" src="../../../assets/img/ss-import.png" width="15" height="15">
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="copy"
                    style="background: rgb(142, 136, 136);border:none"
                    @click="handleToolClick(tt)"
                    v-else-if="tt.code == 'BTN_COPY'"
            ></a-button>
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="printer"
                    style="background: #30bfea;border:1px solid #7e8081;color: #7e8081;"
                    @click="handleToolClick(tt)"
                    v-else-if="tt.code == 'BTN_PRINT'"
            ></a-button>
            <a-button
                    size="small"
                    type="primary"
                    icon="save"
                    v-else-if="tt.code == 'BTN_SAVE' &&  tt.editFlag != '1'"
                    :disabled="disabledBtnList.includes(tt.extValType) ? true : false"
                    @click="handleToolClick(tt)"
            >{{ tt.name }}</a-button>
            <a-button
                    size="small"
                    type="primary"
                    icon="save"
                    v-else-if="tt.code == 'BTN_UPDATE'"
                    @click="handleToolClick(tt)"
            >{{ tt.name }}</a-button>
            <a-button
                    size="small"
                    type="primary"
                    icon="export"
                    v-else-if="tt.code == 'BTN_EXPORT'"
                    @click="handleToolClick(tt)"
            >{{ tt.name }}</a-button>
          </a-tooltip>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      moreHeight: window.innerHeight / 4 * 3,
    };
  },
  props: {
    buttonsObj: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabledBtnList:{
       type: Array,
       required: false,
       default: function() {
            return [];
        }
    }
  },
  methods: {
    handleToolClick(oprType) {
//        if(oprType.code == "BTN_EXPORT" || oprType.code == "BTN_IMPORT" || oprType.code =="BTN_DELETE" || oprType.pattern.custPage != null){
//            this.$store.commit("updataLoading", { pbLoading: false });
//        }else{
//            this.$store.commit("updataLoading", { pbLoading: true });
//        }
      this.$emit("handleToolClick", oprType);
    }
  }
};
</script>
<style lang="less">
#functionBar {
  padding: 0 6px;
  display: flex;
  button {
    border: none;
    margin-left: 4px;
  }
  img{
    margin-left: 4px;
  }

  .deleteclass {
    background: #f5222d;
    border: none;
  }
  .editClass {
    background: #9c9446;
    border: none;
  }
}
</style>
